/*Modal Product*/
export const handelOpenModalProduct = () => ({
    type:'OPEN_MODAL_PRODUCT'
});
export const handelCloseModalProduct = () => ({
    type:'CLOSE_MODAL_PRODUCT'
});

export const handelChangeDataSingleProduct = (data,similar,options = []) => ({
    type: 'CHANGE_BASE_CARD_PRODUCT',data,similar,options
});

export const handelChangeSelectGradeModalProduct = (selectGrade,option) => ({
    type: 'CHANGE_BASE_SELECT_GRADE_MODAL_PRODUCT',selectGrade,option
});

export const actionChangeInputNumberModalProduct = (direction) => ({
    type: 'CHANGE_INPUT_NUMBER_MODAL_PRODUCT',direction
});
export const actionChangeLoaderModalProduct = (loader) => ({
    type: 'CHANGE_LOADER_MODAL_PRODUCT',loader
});

export const actionChangeItemOptions = (name,value) => ({
    type: 'CHANGE_ITEM_OPTION_MODAL_PRODUCT',name,value
});

